import { useState } from "react";
import designedby from '../../Assets/Img/designedby-full-white.png';

export function Header() {
  const [showMore, setShowMore] = useState(false);

  return (
    <div>
      <div className="p-4 pt-10 px-6 sm:px-20 relative flex items-center">
        {/* Icons on right */}
        <div className="flex gap-4 text-3xl decoration-transparent ml-auto">
          <a
            href="https://instagram.com/designedbyyacoreq"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-pink-500 transition"
          >
            <i className="fa-brands fa-instagram" />
          </a>
          <a
            href="https://youtube.com/@designedbyyacoreq"
            target="_blank"
            rel="noopener noreferrer"
            className="text-white hover:text-red-500 transition"
          >
            <i className="fa-brands fa-youtube" />
          </a>
        </div>

        {/* Logo centered on sm+ screens, left aligned on xs */}
        <div className="absolute left-6 sm:left-1/2 sm:transform sm:-translate-x-1/2">
          <img src={designedby} alt="Designed by Yacoreq" className="h-24" />
        </div>
      </div>

      <p className="text-white text-center text-xl mt-6">
        Cześć! Jestem Bartek i lubię robić kreatywne rzeczy!
      </p>

      <div
        className={`transition-all duration-500 overflow-hidden max-w-xl mx-auto text-white text-center text-md px-4 ${showMore ? "max-h-96 mt-4" : "max-h-0"
          }`}
      >
        <p>
          Zajmuję się montażem i grafiką od kilku lat. Swoją pracę wykonuję
          <br />
          w programach od Adobe, które opanowane mam
          niemalże do perfekcji.
        </p>
      </div>

      <button
        onClick={() => setShowMore(!showMore)}
        className="text-link hover:text-blue-600 text-center text-md block mx-auto mt-2"
      >
        {showMore ? "mniej o mnie" : "więcej o mnie"}
      </button>

      <br />
      <br />
    </div>
  );
}
